import React, { useEffect, useRef, useState } from 'react'
import { useParams } from 'react-router-dom'
import { useForm } from 'react-hook-form'
import ListaCestNcmService from 'business/cadastro/fiscal/listaCestNcm/listaCestNcmService'
import OutputSpanForm from 'base/OutputSpanForm'
import ControllerInput from 'base/ControllerInput'
import GridForm from 'base/GridForm'
import { yupResolver } from '@hookform/resolvers/yup'
import FormCadastro, { FormCadastroAux } from 'base/FormCadastro'
import { TabView, TabPanel } from 'primereact/tabview'
import { cd, createCodeDescriptionObject, formatDatetime } from 'helper/formater'
import ListaCestNcmItem from './listaCestNcmItem/ListaCestNcmItem'
import TipoListaCestNcmService from 'business/cadastro/fiscal/tipoListaCestNcm/tipoListaCestNcmService'
import { defaultEmptySelection } from 'helper/default'
import { errorToToast } from 'helper/error'

export default function ListaCestNcm() {

    const [service] = useState(() => new ListaCestNcmService())
    const [listaCestNcms, setListaCestNcms] = useState([])
    const [tipoListaCestNcms, setTipoListaCestNcms] = useState([])

    const stepperRef = useRef(null)
    const toast = useRef(null)
    const { id } = useParams()
    const [validations, setValidations] = useState([])

    const form = useForm({
        defaultValues: async () => await load(),
        resolver: yupResolver(validations),
        mode: "onBlur"
    })

    async function load() {
        const data = await FormCadastroAux.load({ id, service, toast, beforeSubmit, useNew: true })

        if (data?.lista_cest_ncm) {
            setListaCestNcms([createCodeDescriptionObject(data.lista_cest_ncm, 'codigo_lcn', 'descricao_lcn', true)])
        }
        if (data?.tipo_lista_cest_ncm) {
            setTipoListaCestNcms([createCodeDescriptionObject(data.tipo_lista_cest_ncm, 'codigo_tlcn', 'descricao_tlcn', false)])
        }
        return data
    }

    const beforeSubmit = (data) => {
        let submitData = structuredClone(data)
        submitData = service.prepareToSave({ data: submitData })
        return submitData
    }

    useEffect(() => {
        service.getSchema().then(e => {
            setValidations(e)
        })
    }, [service])

    const loadTipoListaCestNcms = async () => {
        const list = new TipoListaCestNcmService()
        await list.list('').then(rs => {
            const options = rs.data.data.map(e => createCodeDescriptionObject(e, 'codigo_tlcn', 'descricao_tlcn', false))
            options.push({ codigo_tlcn: null, descricao_tlcn: defaultEmptySelection() })
            setTipoListaCestNcms(options)
        }).catch(err => errorToToast({ err, toast }))
    }

    return (
        < FormCadastro service={service} form={form} aux={FormCadastroAux} toast={toast} beforeSubmit={beforeSubmit}>

            <TabView ref={stepperRef} className='text-sm' style={{ flexBasis: '1rem' }}>

                <TabPanel header="Capa" leftIcon="pi pi-home mr-2">

                    <GridForm>

                        <ControllerInput addClassName="md:col-6 lg:col-4 xl:col-3" field="descricao_lcn" form={form} service={service} type="text" clearString label="Descrição" />
                        <ControllerInput addClassName="md:col-6 lg:col-4 xl:col-3" field="cod_tlcn_lcn" form={form} type="dropdown2" service={service} label="Tipo de lista de CEST/NCM"
                            optionKey='codigo_tlcn'
                            optionLabel='descricao_tlcn'
                            options={tipoListaCestNcms}
                            onLoad={loadTipoListaCestNcms}
                        />

                        <ListaCestNcmItem form={form} service={service}></ListaCestNcmItem>

                    </GridForm>

                </TabPanel>
                <TabPanel header="Info" leftIcon="pi pi-info-circle mr-2" visible={id > 0}>
                    <GridForm>
                        <OutputSpanForm field="dh_ins_lcn" className="col-12 md:col-4 lg:col-4 xl:col-3 mb-2" form={form} value={formatDatetime(form.getValues('dh_ins_lcn'))} label="Inserção" />
                        <OutputSpanForm field="dh_atua_lcn" className="col-12 md:col-4 lg:col-4 xl:col-3 mb-2" form={form} value={formatDatetime(form.getValues('dh_atua_lcn'))} label="Atualização" />
                        <OutputSpanForm field="usu_ins_lcn" className="col-12 md:col-4 lg:col-4 xl:col-3 mb-2" value={cd({ code: form.getValues('usu_ins_lcn'), description: form.getValues('meta.usuario_ins_nome') })} label="Inserção" />
                        <OutputSpanForm field="usu_atua_lcn" className="col-12 md:col-4 lg:col-4 xl:col-3 mb-2" value={cd({ code: form.getValues('usu_atua_lcn'), description: form.getValues('meta.usuario_atua_nome') })} label="Atualização" />
                    </GridForm>
                </TabPanel>

            </TabView>

        </FormCadastro>
    )
}
